import React from 'react';
import PropTypes from 'prop-types';
import { BASE_URL, API } from 'CONST';
import { Label, Col, Row } from 'reactstrap';
import NewFileTable from 'components/shared/NewFileTable';

const VeedoresSeccionAdjuntos = ({
  newAntecedentes,
  oldAntecedentes,
  setNewAntecedentes,
  setOldAntecedentes,
  removeAdjunto,
  editableSection,
  setIsFormSaved,
}) => {
  const dataAdjuntos = {
    veedores_liquidaciones_ficha: {
      label: 'Ficha',
      adjunto_docs: 'veedores_liquidaciones_ficha_docs',
    },
    veedores_liquidaciones_bce: {
      label: 'BCE',
      adjunto_docs: 'veedores_liquidaciones_bce_docs',
    },
    veedores_liquidaciones_nombramiento: {
      label: 'Nombramiento de la CMF',
      adjunto_docs: 'veedores_liquidaciones_nombramiento_docs',
    },
    veedores_liquidaciones_cv: {
      label: 'CV',
      adjunto_docs: 'veedores_liquidaciones_cv_docs',
    },
    veedores_liquidaciones_estado_situacion_admin_ficha: {
      label: 'Ficha Estado de Situaciones Administradores',
      adjunto_docs: 'veedores_liquidaciones_estado_situacion_admin_ficha_docs',
    },
    veedores_liquidaciones_estado_situacion_admin_bce: {
      label: 'BCE Ficha Estado de Situaciones Administradores',
      adjunto_docs: 'veedores_liquidaciones_estado_situacion_admin_bce_docs',
    },
  };

  return (
    <div>
      {Object.keys(dataAdjuntos).map((key) => {
        return (
          <div key={key}>
            <Row>
              <Col>
                <Label>{dataAdjuntos[key].label}</Label>
              </Col>
              <Col>
                <NewFileTable
                  handleAdd={(file) => {
                    setIsFormSaved(false);
                    setNewAntecedentes((prevState) => ({
                      ...prevState,
                      [key]: [...prevState[key], file],
                    }));
                  }}
                  handleDeleteNew={(file) => {
                    setIsFormSaved(false);
                    setNewAntecedentes((prevState) => ({
                      ...prevState,
                      [key]: prevState[key].filter((doc) => doc.uuid !== file.uuid),
                    }));
                  }}
                  handleDelete={(event) => {
                    setIsFormSaved(false);
                    removeAdjunto(event.id, key);
                    setOldAntecedentes((prevState) => ({
                      ...prevState,
                      [dataAdjuntos[key].adjunto_docs]: prevState[
                        dataAdjuntos[key].adjunto_docs
                      ].filter((doc) => doc.id !== event.id),
                    }));
                  }}
                  uploadUrl={`${BASE_URL}${API.upload}/`}
                  downloadUrl={`${BASE_URL}${API.download}/`}
                  newFiles={newAntecedentes[key]}
                  fileList={oldAntecedentes[dataAdjuntos[key].adjunto_docs]}
                  individualMaxFileSize={13}
                  globalMaxFileSize={20}
                  loginIdToken=""
                  readOnly={!editableSection}
                />
              </Col>
            </Row>
            <br />
          </div>
        );
      })}
    </div>
  );
};

VeedoresSeccionAdjuntos.propTypes = {
  newAntecedentes: PropTypes.shape().isRequired,
  oldAntecedentes: PropTypes.shape().isRequired,
  setNewAntecedentes: PropTypes.func.isRequired,
  setOldAntecedentes: PropTypes.func.isRequired,
  removeAdjunto: PropTypes.func.isRequired,
  editableSection: PropTypes.bool,
  setIsFormSaved: PropTypes.func.isRequired,
};

VeedoresSeccionAdjuntos.defaultProps = {
  editableSection: false,
};

export default VeedoresSeccionAdjuntos;
